var EHDI = EHDI || Object.create(null);
var WAG = WAG || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

WAG.GameEngine  = function() 
{

    var TIME_LIMIT = EHDI.GAME.constants.gametimelimit;
    var SCORE_TIME = 1000;
    var OVER_TIME_SCORE = 10;
    var GLOWING_PLANT_COUNT = 2;
    EHDI.aka.Container.call(this);

    var bg;
    var timer;
    var spawnTimer;
    var speed = EHDI.GAME.constants.gameinitspeed;
    var accel = (EHDI.GAME.constants.gamefinalspeed - EHDI.GAME.constants.gameinitspeed)/TIME_LIMIT;
    var field = new EHDI.aka.Container();

    var weeds = [];
    var isOver;

    var ySpawn = [250, 350, 450, 550];
    var simulSpawnCount = 0;
    
    var pauseBtn;

    var missedClick;
    var tutorialQueue = [1, null, null, null, null, 2, null, null, null, null, 0, null, null, null, null, 1, null, null,1, null, null,1, null, null, null, null,2, null, null,2, null, null,2, null, null, null, null,0, null, null,0, null, null, null, null];

    var leftBound;
    var currentSpawnX;

    var speedOffset;
    var scoreTimer =0;
    var glowingPlantCounter;

    this.init = function()
    {
        bg = new PIXI.extras.TilingSprite(EHDI.Assets.images["bg_weeds"], EHDI.GAME.sceneManager.getStageWidth(), EHDI.GAME.sceneManager.getStageHeight());
        this.addChild(bg);
        this.addChild(field);

        timer =0;
        simulSpawnCount =1;
        spawnTimer = EHDI.GAME.constants.spawndelay;
        isOver = false;
        missedClick = false;
        leftBound = 0;
        speedOffset =0;
        glowingPlantCounter=0;
        currentSpawnX = EHDI.GAME.sceneManager.getStageWidth();
        this.scoreEffects = new EHDI.components.ScoreEffectManager();
        this.scoreEffects.init(field);
    }

    this.fieldClicked = function()
    {
        missedClick = true;
    }

    this.gameStart = function()
    {
        pauseBtn =EHDI.GAME.pauseButton;

        this.addInteraction();
        
        this.bindedLoop = gameUpdate.bind(this);
        EHDI.GAME.updateManager.addFrameListener(this.bindedLoop);
    }

    var gameUpdate= function(delta)
    {
        if((pauseBtn.isPaused) || (pauseBtn.isEndGame))
            {                
                return;
            }
        timer += delta;
        if((timer >=  TIME_LIMIT) || (isOver))
            {
                this.gameOver();
                return;
            }

      
        scoreTimer += delta;
        if(scoreTimer >= SCORE_TIME)
            {
                scoreTimer -= SCORE_TIME;
                EHDI.scene.GameScene.scoreHolder.addScore(OVER_TIME_SCORE);                
                this.scoreEffects.popScore((field.x *-1) + 650, 100, OVER_TIME_SCORE);
            }

        speedOffset = delta * speed;
        speed += delta * accel;

        field.x -= speedOffset;
        leftBound += speedOffset;
        bg.tilePosition.x -= speedOffset;
        currentSpawnX += speedOffset;
        
        simulSpawnCount = timer / 30000;

        spawnTimer -= delta;
        if (spawnTimer <= 0)
            {
                spawnTimer = EHDI.GAME.constants.spawndelay;// + (Math.random() * 350);
                spawnGrass();
            }
        
        if(weeds.length > 0)
        {
            var toCut = [];
            for(var i = 0, l = weeds.length; i<l; i++)
                {
                    var weed = weeds[i];

                    if(weed.update(delta))
                        {
                            toCut.push(weed);
                            field.removeChild(weed);
                            missedClick = false;

                            
                            var armature = EHDI.DBoneFactory.createArmature("fx_sparkle_armature");
                            var animationSprite = armature.getDisplay();
                            var animList = armature.animation.animationList;
                            armature.animation.gotoAndPlay(animList[0], -1, -1, 1);
                            animationSprite.x = weed.x;
                            animationSprite.y = weed.y - 25;
                            field.addChild(animationSprite);
                        }
                    else if(weed.x < leftBound)
                    {

                        if(!weed.isTrap)
                            {
                                this.gameOver();
                                return;
                            }
                        else
                            {
                                toCut.push(weed);
                            }
                    }

                }

            POOLS.weedPool.returnBatch(weeds, toCut);
        }

        this.scoreEffects.update(delta);

        if(missedClick)
            this.gameOver();

        missedClick = false;
    }

    this.gameOver = function()
    {
        if(isOver)
            return;

        isOver = true;        
        EHDI.GAME.soundManager.playSFX("score_points"); //error like sound
        this.removeInteraction();

        EHDI.GAME.pauseButton.endGame();
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp(getStarRating(), EHDI.scene.GameScene.scoreHolder.getScore()), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
        
        this.scoreEffects.hideScores();
    }

    var spawnGrass = function()
    {
        if(tutorialQueue.length > 0)
            {
                forcePlantGrass(tutorialQueue.shift());
                return;
            }


        var rowSpawned = [];

        var spawnCount =  Math.floor(Math.random() *(Math.ceil(simulSpawnCount)+1));

        var i =0;
        while(i < spawnCount)
        {

            var weed = POOLS.weedPool.takeFromPool();
            weed.x = currentSpawnX;

            var spawnRow =0; 
            do
            {
                spawnRow = ySpawn[Math.floor(Math.random() * ySpawn.length)];
            }while(rowSpawned.indexOf(spawnRow) != -1);
            rowSpawned.push(spawnRow);
            weed.y = spawnRow;
            weed.init();
            field.addChild(weed);

            weeds.push(weed);
            i++;
        }

        
        UTILS.depthSwap(field.children);
    }

   
    var forcePlantGrass = function(type)
    {
        if(type == null)
            return;

        var weed = POOLS.weedPool.takeFromPool();
        weed.x = currentSpawnX;

        weed.y = ySpawn[Math.floor(Math.random() * ySpawn.length)];;
        weed.init(type, (glowingPlantCounter < GLOWING_PLANT_COUNT));
        glowingPlantCounter++;
        field.addChild(weed);

        weeds.push(weed);
    }

    var getStarRating = function()
    {
        var rating = Math.floor(timer / 15000);

        if(rating > 3)
            rating =3;
        
        return rating;
    }
    
    this.addInteraction = function()
    {
        if(EHDI.BrowserInfo.isMobileDevice)
            bg.on('touchstart', this.fieldClicked);            
        else
            bg.on('mousedown', this.fieldClicked);

        bg.interactive = true;
    }

    this.removeInteraction = function()
    {
        if(EHDI.BrowserInfo.isMobileDevice)
            bg.off('touchstart', this.fieldClicked);            
        else
            bg.off('mousedown', this.fieldClicked);

        bg.interactive = false;
    }

}
WAG.GameEngine.prototype = Object.create(EHDI.aka.Container.prototype);

